(() => {
  window.Llovable = window.Llovable || {};
  if (window.Llovable.initGiftCountdowns) {
    window.Llovable.initGiftCountdowns(document);
    return;
  }
  const clocks = new Map();
  const deadlines = new Map();
  let interval;
  const readDeadline = value => {
    const number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  };
  const deadlineFor = node => {
    const key = `llovable:gift-window:${node.dataset.countdownCampaign}`;
    const now = Date.now();
    let deadline = deadlines.get(key);
    if (!deadline || deadline <= now) {
      try { deadline = readDeadline(localStorage.getItem(key)); } catch (_) {}
    }
    if (!deadline || deadline <= now) {
      const duration = Math.max(60, Number(node.dataset.countdownSeconds) || 11400);
      const variation = Math.max(0, Math.min(duration - 60, Number(node.dataset.countdownVariation) || 0));
      deadline = now + (duration - Math.floor(Math.random() * (variation + 1))) * 1000;
      try { localStorage.setItem(key, String(deadline)); } catch (_) {}
    }
    deadlines.set(key, deadline);
    return deadline;
  };
  const tick = () => {
    for (const [node, savedDeadline] of clocks) {
      if (!node.isConnected) { clocks.delete(node); continue; }
      let deadline = savedDeadline;
      if (deadline <= Date.now()) {
        deadline = deadlineFor(node);
        clocks.set(node, deadline);
      }
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      node.hidden = false;
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      node.querySelector('[data-countdown-time]').textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
    }
    if (!clocks.size && interval) { clearInterval(interval); interval = undefined; }
  };
  const init = root => {
    root.querySelectorAll('[data-lln-gift-countdown]').forEach(node => {
      if (node.dataset.countdownReady) return;
      node.dataset.countdownReady = 'true';
      clocks.set(node, deadlineFor(node));
    });
    tick();
    if (clocks.size && !interval) interval = setInterval(tick, 1000);
  };
  window.Llovable.initGiftCountdowns = init;
  document.addEventListener('visibilitychange', tick);
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
